import {
  Col,
  Flex,
  message,
  Row,
  Tag,
  Timeline,
  Input,
  Dropdown,
  Tooltip,
  Collapse,
  Space,
  Card,
  Button,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { PhoneOutlined, MailOutlined, BellFilled } from "@ant-design/icons";
import { ReactComponent as StarIcon } from "../../assets/images/star.svg";
import FilterIconBlack from "../../assets/images/filter-list-black.svg";
import FileUploadModal from "./FileUploadModal";
import CustomTitle from "../../components/CustomTitle";
import arrowLink from "../../assets/images/arrowLink.png";
import {
  initiateAiCall,
  initiateAiCallValidate,
  initiateAiEmail,
  initiateAiEmailValidate,
  shipmentAlertAiStatus,
} from "../../api's/shipment";
import mail from "../../assets/images/mailFilled.svg";
import { GetShipmentsViewers } from "../../api's/shipment";
import {
  ExclamationCircleFilled,
  LeftOutlined,
  RightOutlined,
  MinusOutlined,
  CloseOutlined,
  FullscreenOutlined,
  WarningFilled,
  CheckOutlined,
} from "@ant-design/icons";
import ShareIcon from "../../assets/images/share-icon.svg";
import EditIcon from "../../assets/images/edit-icon.svg";
import shipmentWebSocketService from "../../context/shipmentWebSocketService";
import ArchiveOptionsIcon from "../../assets/images/archiveOptions.svg";
import { ArchiveIcon, CheckmarkIcon } from "../../assets/icons/icons";
import DeleteBlackIcon from "../../assets/images/delete-black.svg";
import PressureChartModal from "../Modals/PressureChartModal";
import {
  CustomParagraph,
  CustomButton,
  CustomImage,
  CustomModalWithoutButton,
} from "../../components";
import {
  GoogleMapsProvider,
  useGoogleMaps,
} from "../../components/GoogleMapsProvider";
import { GoogleMap, Marker } from "@react-google-maps/api";
import StatusCardNotification from "../../components/StatusCardNotification";
import CustomModal from "../../components/CustomModal";
import ShareShipment from "../Modals/ShareShipment";
import ShipmentMap from "./ShipmentMap";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../components/SpinContext";
import {
  ArchiveShipment,
  GetShipmentAlerts,
  GetSingleShipment,
  MarkAsDelivered,
  ResolveAlertComments,
  ResolvedAlert,
} from "../../api's/shipment";
import { useToken, appHelper } from "../../common/helper";
import { ChainOfCustodyComments } from "../../api's/shipment";
import temp from "../../assets/images/temp.png";
import battery from "../../assets/images/battery.png";
import AtRisk from "../../assets/images/yellow Avatar.png";
import CommentIcon from "../../assets/images/comment.png";
import UploadIcon from "../../assets/images/uploadIcon.svg";
import FileDownload from "../../assets/images/fileDownload.svg";
import tempratureIcon from "../../assets/images/temprature-icon.svg";
import tempratureIconRed from "../../assets/images/temprature-icon-red.svg";
import lightIcon from "../../assets/images/lightIcon.svg";
import humidityIcon from "../../assets/images/humidityIcon.svg";
import humidityIconRed from "../../assets/images/humidityIconRed.svg";
import batteryIcon from "../../assets/images/battery-icon.svg";

import tiltIcon from "../../assets/images/tiltIcon.svg";
import pressureIcon from "../../assets/images/pressureIcon.svg";

import time from "../../assets/images/time.png";
import TemperatureModal from "../Modals/TempratureModal";
import phone from "../../assets/images/phone.svg";
import phoneblack from "../../assets/images/phoneBlack.svg";
import BatteryModal from "../Modals/BatteryModal";
import FileImg from "../../assets/images/FILE.png";
import BlackIcon from "../../assets/images/Avatar.png";
import CriticalImage from "../../assets/images/Artwork trailing.png";
import ShipmentCommentBox from "./ShipmentCommentBox";
import HumidityModal from "../Modals/HumidityModal";
import LightModal from "../Modals/LightModal";
import CircleGroup from "./CircleGroup";
import ShipmentMultipleProductDetail from "./ShipmentMultipleProductDetail";
import { useSelector } from "react-redux";
import CallAiAssistantModal from "./CallAiAssistantModal";
import AiCallTranscriptModal from "./AiTranscriptModal";
import EmailAiAssistantModal from "./EmailAiAssistantModal";
import EmailTranscriptModal from "./EmailTranscriptModal";
import AiEmailExchangeModal from "./AIEmailExchangeModal";
import CommonDrawer from "../../components/CommonDrawer";
import ShipmentNotificationDrawer from "./ShipmentNotifications/ShipmentNotificationDrawer";
import {
  HumidityIcon,
  PressureIcon,
  TiltIcon,
  LightIcon,
  ShockIcon,
  TempratureRangeIcon,
  BatteryIcon,
  VibilityWindowIcon,
} from "../../assets/icons/icons.js";
import TiltModal from "../Modals/TiltModal.jsx";
const dummyFileUrl = "https://example.com/dummy-file.pdf";
const { TextArea } = Input;

const TagColor = {
  0: "#FFF0EE",
  1: "#FDF2DC",
  2: "#EAF6ED",
  3: "#28a745",
  4: "#F3F3F3",
};

const TextColor = {
  0: "#DE1135",
  1: "#9F6402",
  2: "#0E8345",
  3: "#fff",
  4: "#4b4b4b",
};

function ShipmentDetailDrawerWithTeams({
  isOpen,
  toggleDrawer,
  openShipmentId,
  shipmentSuccess,
  drawerState,
  filterByLinkCode,
}) {
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken, decodedUserToken, getUserID } = useToken();
  const [shipmentId, setShipmentId] = useState(openShipmentId);
  useEffect(() => {
    handleToggleAlertInput();
    setShipmentId(openShipmentId);
  }, [openShipmentId]);
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  let decodedToken = decodedUserToken();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const companyName = decodedToken?.company_name;
  const { capitalize, formatDateToDayMonthYear, changeToTimeString } =
    appHelper();
  const [openCommentInput, setOpenCommentInput] = useState(false);
  const [showTranscriptModal, setShowTranscriptModal] = useState(false);
  const [openAlertInput, setOpenAlertInput] = useState(false);
  const [comments, setComments] = useState("");
  const [alertComment, setAlertComment] = useState("");
  const [isResolved, setIsResolved] = useState(true);
  const [commentsInputError, setCommentsInputError] = useState(false);
  const [lastPoint, setLastPoint] = useState(null);
  const [alertsData, setAlertsData] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [alertID, setAlertID] = useState();

  const [tempratureModalOpen, setTempratureModalOpen] = useState();
  const [tiltModalOpen, setTiltModalOpen] = useState(false);

  const [pressureModalOpen, setPressureModalOpen] = useState();
  const [batteryModalOpen, setBatteryModalOpen] = useState();

  //all states for alerts Array
  const [alertsArray, setAlertsArray] = useState([]);
  const [alertIndex, setAlertIndex] = useState(0);
  const [startAlertsInterval, setStartAlertsInterval] = useState(true);
  const navigate = useNavigate();
  const { Panel } = Collapse;
  const { isLoaded } = useGoogleMaps();
  const [shareShipmentModalOpen, setShareShipmentModalOpen] = useState(false);
  const [deleteShipmentModalOpen, setDeleteShipmentModalOpen] = useState(false);
  const [lightModalOpen, setLightModalOpen] = useState(false);
  const [humidityModalOpen, setHumidityModalOpen] = useState(false);
  const [showAiModal, setShowAiModal] = useState(false);
  const [showExchangeModal, setShowExchangeModal] = useState(false);
  const [showEmailAiModal, setShowEmailAiModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shipment, setShipment] = useState({});
  const [alert, setAlert] = useState({});
  const [selectedAlert, setSelectedAlert] = useState(null);
  const [viewers, setViewers] = useState([]);

  const mainMenu = useSelector((state) => state.menu.items);
  const shipmentPermissions = mainMenu?.find(
    (items) => items?.name.toLowerCase() == "shipment"
  );
  const allPermissions = shipmentPermissions?.permissions;

  const prevAlertsRef = useRef([]);

  useEffect(() => {
    if (alertsArray && alertsArray.length > 0) {
      alertsArray.forEach((newAlert) => {
        const oldAlert = prevAlertsRef.current.find(
          (a) => a.id === newAlert.id
        );
        if (oldAlert) {
          // Check for AI Call status changes
          if (
            oldAlert.ai_status === "ai_call_in_progress" &&
            (newAlert.ai_status === "ai_call_completed" ||
              newAlert.ai_status === "ai_call_failed")
          ) {
            message.success(
              `AI Call for '${newAlert.title || "N/A"}' analysis complete.`
            );
          }
          // Check for AI Email status changes
          if (
            oldAlert.ai_status === "ai_email_in_progress" &&
            (newAlert.ai_status === "ai_email_completed" ||
              newAlert.ai_status === "ai_email_failed")
          ) {
            message.success(
              `AI Email for '${newAlert.title || "N/A"}' analysis complete.`
            );
          }
        }
      });
      // Store a deep enough copy for comparison
      prevAlertsRef.current = alertsArray.map((a) => ({
        id: a.id,
        ai_status: a.ai_status,
        title: a.title,
      }));
    } else {
      prevAlertsRef.current = [];
    }
  }, [alertsArray]);

  useEffect(() => {
    const fetchViewers = () => {
      GetShipmentsViewers(token, shipmentId)
        .then((res) => {
          const data = res?.data ? res.data : null;
          if (data) {
            if (data?.data?.is_success) {
              setViewers(data?.data?.data);
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };

    fetchViewers();
    const interval = setInterval(() => {
      fetchViewers();
    }, 30000);

    return () => clearInterval(interval);
  }, [shipmentId, token]);

  useEffect(() => {
    if (token && shipmentId) {
      const baseDomain = process.env.REACT_APP_WEB_SOCKETS;
      const wsUrl = `${baseDomain}/shipment/123/?shipmentId=${shipmentId}&token=${token}`;

      shipmentWebSocketService.connect(wsUrl);
    }

    return () => {
      shipmentWebSocketService.disconnect();
    };
  }, [token, shipmentId]);

  const handleShareShipmentModal = () => {
    setShareShipmentModalOpen(true);
  };

  // const handleDeleteShipmentModal = () => {
  //     console.log('clicked')
  //     setDeleteShipmentModalOpen(true);
  // }
  // const handleToggleAlertInput = () => {
  //     setOpenAlertInput(false)
  //     setAlertComment('')
  //     setAlertID(null);
  //     setAlertIndex(alertsArray.length>0 ? 0 : -1);
  //     getShipmentAlerts();
  //     setStartAlertsInterval(true);
  //     fetchSingleShipmentData();
  // }

  const handleEditShipmentModal = () => {
    //openShipmentModal();
    toggleDrawer("open", "Edit", shipmentId);
  };
  const goToExternalView = () => {
    navigate(`/shipment/external-view/${shipmentId}`);
  };

  const onAddCommentClick = () => {
    setOpenCommentInput(true);
    resetComments();
  };

  const resolvedAlert = () => {
    if (alertsData && alertsData?.id) {
      ResolvedAlert(token, alertsData?.id)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              setAlertType(null);
              // onAddCommentClick();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const onTextareaChange = (e) => {
    let val = e.target.value;
    if (val) {
      setComments(val);
    }
  };

  // const onAlertTextareaChange = (e) => {
  //     let val = e.target.value
  //     if (val) {
  //         setAlertComment(val);
  //     }
  // }

  const onSubmitComments = () => {
    if (comments) {
      let model = {
        chain_of_custody: shipmentId,
        comment: comments,
      };
      if (alertID) {
        model.alert_id = alertID;
      }
      ChainOfCustodyComments(token, model)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              onCancelComments();
              fetchSingleShipmentData();
              setOpenAlertInput(false);
              setAlertID(null);
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    } else {
      setCommentsInputError(true);
    }
  };
  const handleAiEmailConfirm = (alertData, emailMessage, emailSubject) => {
    if (!alertData || !shipment) {
      console.warn("Shipment is not ready yet.");
      return;
    }

    const recipientName = shipment?.tp_primary_contact?.name;

    const payload = {
      ai_alert_event_uuid: alertData?.id,
      company: companyName,
      triggered_by: getUserID(),
      language: shipment.tp_primary_contact.preferred_language,
      alert: {
        name: alertData?.title,
        description: alertData?.detail,
        severity: { type: alertData?.notification_type },
        recommendedAction: alertData?.detail,
        trigger: {
          thresholdValue: alertData?.trigger?.thresholdValue ?? 0,
          thresholdExplanation:
            alertData?.trigger?.thresholdExplanation ??
            "No threshold explanation provided",
          currentValue: alertData?.trigger?.currentValue ?? null,
          unit: alertData?.trigger?.unit ?? "km",
          timestamp: alertData?.trigger?.timestamp ?? new Date().toISOString(),
        },
      },
      shipment: {
        referenceId: shipment?.reference_number,
        currentLocation: {
          lat: shipment?.latest_location?.latest_lat ?? null,
          lng: shipment?.latest_location?.latest_long ?? null,
          address: shipment?.latest_location?.address ?? "Unknown",
        },
        destination: {
          address: shipment?.to_location?.address,
           eta: shipment?.transport_provider_eta,
          notes: shipment?.to_location?.notes ?? "",
        },
        temperature: {
          current: shipment?.temperature?.current,
          range: {
            min: shipment?.product?.temperature_min,
            max: shipment?.product?.temperature_max,
          },
          uom: shipment?.product?.temperature_unit ?? "C",
        },
        status: {
          pickupTime: shipment?.actual_pickup_date,
          lastUpdate: shipment?.updated_at,
          delivered: shipment?.status,
        },
        transport: {
          provider: shipment?.courier?.title,
          trackingId: shipment?.courier_tracking_id,
          status: shipment?.delivery_status,
        },
        sensor: {
          id: shipment?.sensor_id,
          type: shipment?.sensor?.type,
          battery: {
            currentLevel: shipment?.sensor?.battery?.currentLevel,
            estimatedLife: shipment?.sensor?.battery?.estimatedLife,
            uom: shipment?.sensor?.battery?.uom ?? "hours",
          },
        },
        viabilityWindow: {
          remainingTime: shipment?.schedule_viability_window,
          endTime: null,
          isCritical: alertData?.isCritical,
        },
      },
      contacts: shipment?.tp_primary_contact
        ? {
            primary: {
              name: shipment.tp_primary_contact.name,
              phone: shipment.tp_primary_contact.phone,
              role: shipment.tp_primary_contact.role,
            },
          }
        : {},
      email: {
        to_email: shipment?.tp_primary_contact?.email,
        to_name: shipment?.tp_primary_contact?.name,
        subject: emailSubject,
        body_html: emailMessage.replace(/\n/g, "<br/>"),
        body_text: emailMessage,
        from_email: "customer@zoomlogi.com",
        from_name: decodedToken?.name,
        reply_to: "customer@zoomlogi.com",
      },
    };

    const aiStatusPayload = {
      alert_id: alertData?.id,
      ai_status: "ai_email_in_progress",
      primary_contact: shipment?.tp_primary_contact
        ? {
            name: shipment.tp_primary_contact.name,
            email: shipment.tp_primary_contact.email,
            role: shipment.tp_primary_contact.role,
            phone: shipment.tp_primary_contact.phone,
            language: shipment.tp_primary_contact.preferred_language,
          }
        : {},
    };

    // console.log({ payload, aiStatusPayload });
    showSpin();

    initiateAiEmailValidate(payload)
      .then((res) => {
        if (res?.status === "success") {
          // message.success("Validation successful. Sending AI email...");
          return initiateAiEmail(payload);
        } else {
          message.error(
            res?.data?.data?.message || "AI email validation failed"
          );
          throw new Error("AI email validation failed");
        }
      })
      .then((emailRes) => {
        if (emailRes?.status === "success") {
          message.success("AI email sent successfully.");
          return shipmentAlertAiStatus(token, aiStatusPayload);
        } else {
          message.error(
            emailRes?.data?.data?.message || "AI email sending failed"
          );
          throw new Error("AI email sending failed");
        }
      })
      .then((statusRes) => {
        if (statusRes?.data?.data?.is_success === true) {
          // Manually update alertsArray to reflect the "in_progress" state
          setAlertsArray((prevAlerts) =>
            prevAlerts.map((alert) =>
              alert.id === alertData.id
                ? { ...alert, ai_status: "ai_email_in_progress" }
                : alert
            )
          );
          fetchShipmentAlertData();
          // message.success("AI email sent successfully.");
          setShowEmailModal(false);
        }
      })
      .catch((error) => {
        console.error("AI Email Error:", error);
        message.error(
          error?.data?.message || error.message || "Something went wrong"
        );
      })
      .finally(() => {
        hideSpin();
      });
  };

  const handleAiCallConfirm = (alertData) => {
    if (!alertData || !shipment) {
      message.error("Shipment is not ready yet.");
      return;
    }

    const aiCallPayload = {
      ai_alert_event_uuid: alertData?.id,
      company: decodedToken?.company_name,
      triggered_by: getUserID(),
      language: shipment.tp_primary_contact.preferred_language,
      alert: {
        name: alertData?.title,
        description: alertData?.detail,
        severity: { type: alertData?.notification_type },
        recommendedAction: alertData?.detail,
        trigger: {
          thresholdValue: alertData?.trigger?.thresholdValue ?? 0,
          thresholdExplanation:
            alertData?.trigger?.thresholdExplanation ??
            "No threshold explanation provided",
          currentValue: alertData?.trigger?.currentValue ?? null,
          unit: alertData?.trigger?.unit ?? "km",
          timestamp: alertData?.trigger?.timestamp ?? new Date().toISOString(),
        },
      },
      shipment: {
        referenceId: shipment?.reference_number,
        currentLocation: {
          lat: shipment?.latest_location?.latest_lat ?? null,
          lng: shipment?.latest_location?.latest_long ?? null,
          address: shipment?.latest_location?.address ?? "Unknown",
        },
        destination: {
          address: shipment?.to_location?.address,
          eta: shipment?.transport_provider_eta,
          notes: shipment?.to_location?.notes ?? "",
        },
        temperature: {
          current: shipment?.temperature?.current,
          range: {
            min: shipment?.product?.temperature_min,
            max: shipment?.product?.temperature_max,
          },
          uom: shipment?.product?.temperature_unit ?? "C",
        },
        status: {
          pickupTime: shipment?.actual_pickup_date,
          lastUpdate: shipment?.updated_at,
          delivered: shipment?.status,
        },
        transport: {
          provider: shipment?.courier?.title,
          trackingId: shipment?.courier_tracking_id,
          status: shipment?.delivery_status,
        },
        sensor: {
          id: shipment?.sensor_id,
          type: shipment?.sensor?.type,
          battery: {
            currentLevel: shipment?.sensor?.battery?.currentLevel,
            estimatedLife: shipment?.sensor?.battery?.estimatedLife,
            uom: shipment?.sensor?.battery?.uom ?? "hours",
          },
        },
        viabilityWindow: {
          remainingTime: shipment?.schedule_viability_window,
          endTime: null,
          isCritical: alertData?.isCritical,
        },
      },
      contacts: shipment?.tp_primary_contact
        ? {
            primary: {
              name: shipment.tp_primary_contact.name,
              phone: shipment.tp_primary_contact.phone,
              role: shipment.tp_primary_contact.role,
            },
          }
        : {},
    };

    const aiStatusPayload = {
      alert_id: alertData?.id,
      ai_status: "ai_call_in_progress",
      primary_contact: shipment?.tp_primary_contact
        ? {
            name: shipment.tp_primary_contact.name,
            email: shipment.tp_primary_contact.email,
            role: shipment.tp_primary_contact.role,
            phone: shipment.tp_primary_contact.phone,
            language: shipment.tp_primary_contact.preferred_language,
          }
        : {},
    };

    console.log("ca;ll payload", { aiCallPayload, aiStatusPayload });
    showSpin();

    initiateAiCallValidate(aiCallPayload)
      .then((res) => {
        if (res?.status === "success") {
          // message.success("AI call validation successful."); // Removed this toast
          return initiateAiCall(aiCallPayload);
        } else {
          message.error(
            res?.data?.data?.message || "AI call validation failed"
          );
          throw new Error("AI call validation failed");
        }
      })
      .then((callRes) => {
        if (callRes?.status === "success") {
          message.success("AI call initiated successfully."); // This will be the primary success toast
          return shipmentAlertAiStatus(token, aiStatusPayload);
        } else {
          message.error(
            callRes?.data?.data?.message || "AI call failed to initiate"
          );
          throw new Error("AI call failed to initiate");
        }
      })
      .then((statusRes) => {
        if (statusRes?.data?.data?.is_success === true) {
          // Manually update alertsArray to reflect the "in_progress" state
          setAlertsArray((prevAlerts) =>
            prevAlerts.map((alert) =>
              alert.id === alertData.id
                ? { ...alert, ai_status: "ai_call_in_progress" }
                : alert
            )
          );
          fetchShipmentAlertData();
          // message.success(statusRes?.data?.data?.message); // Removed this toast
          setShowAiModal(false);
        }
      })
      .catch((error) => {
        console.error("AI Call Error:", error);
        message.error(
          error?.data?.message || error.message || "Something went wrong"
        );
      })
      .finally(() => {
        hideSpin();
      });
  };

  // const onSubmitAlertComment = () => {
  //     let model = {
  //         is_resolved: isResolved,
  //         pk_list: [alertID],
  //         comment: alertComment
  //     };

  //     ResolveAlertComments(token, model)
  //         .then((res) => {
  //             const data = res?.data || null;
  //             if (data) {
  //                 if (data?.data?.is_success) {
  //                     handleToggleAlertInput();
  //                     // setAlertIndex(alertsArray.length>0 ? 0 : -1)
  //                     // fetchSingleShipmentData();
  //                     // getShipmentAlerts();
  //                 } else {
  //                     message.error(data?.data?.message);
  //                 }
  //             }
  //         })
  //         .catch((error) => {
  //             unauthorize(error);
  //         }).finally(() => {
  //             hideSpin();
  //         });

  // }

  const resetComments = () => {
    setComments("");
    setCommentsInputError(false);
  };

  const onCancelComments = () => {
    setOpenCommentInput(false);
    resetComments();
  };

  useEffect(() => {
    if (isOpen) {
      setShipment(null);
      setLastPoint(null);
      fetchSingleShipmentData(true);
    }
  }, [isOpen, shipmentId]);

  const fetchSingleShipmentData = (isSpin = true) => {
    let t = localStorage.getItem("@token");
    if (isSpin) {
      showSpin();
    }
    GetSingleShipment(t, shipmentId)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              setShipment(resp);
              if (resp?.shipment_monitor && resp?.shipment_monitor.length > 0) {
                let lp =
                  resp.shipment_monitor[resp.shipment_monitor.length - 1];
                let newPoint = null;

                if (
                  typeof lp.latitude === "number" &&
                  typeof lp.longitude === "number" &&
                  lp.latitude !== 0 &&
                  lp.longitude !== 0
                ) {
                  newPoint = {
                    lat: lp.latitude,
                    lng: lp.longitude,
                  };
                }

                setLastPoint(newPoint);
              }
            }
          } else {
            // message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (isOpen) {
      getShipmentAlerts();
    }
  }, [isOpen, shipmentId]);

  // <------------Functions relative to alerts array------------>

  //Alerts Array call
  const getShipmentAlerts = () => {
    // showSpin();
    GetShipmentAlerts(token, shipmentId)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            setAlertsArray([]);
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              let arr = [];

              // if (resp?.critical && resp?.critical.length > 0) {
              //     resp?.critical.forEach(element => {
              //         arr.push(element)
              //     });
              // }
              // if (resp?.at_risk && resp?.at_risk.length > 0) {
              //     resp?.at_risk.forEach(element => {
              //         arr.push(element)
              //     });
              // }
              setAlertsArray(resp);
              // setAlertIndex(0)
              setAlertsData(resp);
              setAlertType(resp.alert_type);
            }
          } else {
            // message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };
  const fetchShipmentAlertData = () => {
    if (isOpen) {
      getShipmentAlerts();
      fetchSingleShipmentData(false);
    }
  };
  useEffect(() => {
    if (startAlertsInterval) {
      const intervalId = setInterval(() => {
        fetchShipmentAlertData();
      }, 30000);
      return () => clearInterval(intervalId);
    }
  }, [isOpen, shipmentId, startAlertsInterval]);

  //when mark as resolved or dismiss gets clicked
  const handleAlertResolved = (val, id) => {
    setIsResolved(val);
    setAlertID(id);
    setOpenAlertInput(true);
    setStartAlertsInterval(false);
  };

  const handleDismissedAlert = (val, id) => {
    setIsResolved(val);
    setAlertID(id);
    setOpenAlertInput(false);
    setStartAlertsInterval(false);

    let model = {
      is_resolved: val,
      pk_list: [id],
    };
    ResolveAlert(model);
  };
  const downloadFile = (fileUrl) => {
    if (!fileUrl) {
      message.error("File not found!");
      return;
    }

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "file"); // ⚡ Ensures the file is downloaded, not opened
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the DOM
  };

  //alerts fuction when comment cancel clicks or submit is  successful
  const handleToggleAlertInput = () => {
    setOpenAlertInput(false);
    setAlertComment("");
    setAlertID(null);
    setStartAlertsInterval(true);
  };

  //when comments inut for alert enter
  const onAlertTextareaChange = (e) => {
    let val = e.target.value;
    if (val) {
      setAlertComment(val);
    }
  };

  //when alert comment success clicks
  const onSubmitAlertComment = () => {
    let model = {
      is_resolved: isResolved,
      pk_list: [alertID],
      comment: alertComment,
    };
    ResolveAlert(model);
  };

  const ResolveAlert = (model) => {
    ResolveAlertComments(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            handleToggleAlertInput();
            let alertsInd = alertIndex;
            if (alertsArray.length > 0) {
              if (alertsInd < alertsArray.length - 1) {
                setAlertIndex(alertsInd + 1);
              } else {
                setAlertIndex(0);
              }
            } else {
              setAlertIndex(0);
            }
            getShipmentAlerts();
            fetchSingleShipmentData();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };
  const handleLightModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setLightModalOpen(true);
    }
  };
  const handleHumidityModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setHumidityModalOpen(true);
    }
  };

  const handleTempratureModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setTempratureModalOpen(true);
    }
  };

  const handleTiltModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setTiltModalOpen(true);
    }
  };
  const handlePressureModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setPressureModalOpen(true);
    }
  };

  const handleBatteryModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setBatteryModalOpen(true);
    }
  };
  // archive options
  const items = [
    {
      key: "edit_shipment",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={EditIcon}
            alt="Edit"
            style={{ width: "12px", height: "12px" }}
          />
          <span
            style={{
              marginLeft: "8px",
              paddingRight: "16px",
              fontSize: "12px",
            }}
          >
            Edit shipment
          </span>
        </span>
      ),
    },
    {
      key: "archive_shipment",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <ArchiveIcon size={12} />
          <span
            style={{
              marginLeft: "8px",
              paddingRight: "16px",
              fontSize: "12px",
            }}
          >
            Archive shipment
          </span>
        </span>
      ),
    },
    {
      key: "mark_as_delivered",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <CheckmarkIcon size={12} />
          <span
            style={{
              marginLeft: "8px",
              paddingRight: "16px",
              fontSize: "12px",
            }}
          >
            Mark as delivered
          </span>
        </span>
      ),
    },
  ];

  //   confirm archive modal
  const handleDeleteShipmentModal = () => {
    let model = {
      shipment_id: shipmentId,
    };
    ArchiveShipment(model, token).then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          toggleDrawer("close");
          shipmentSuccess();
          setDeleteShipmentModalOpen(false);
          message.success(data?.data?.message);
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  };

  //   mark as delivered shipment
  const handleMarkAsDevliered = () => {
    let model = {
      shipment_id: shipmentId,
    };
    MarkAsDelivered(token, model).then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          toggleDrawer("close");
          shipmentSuccess();
          message.success(data?.data?.message);
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  };
  const truncateByLength = (text, maxLength = 23) => {
    if (!text) return "";
    return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
  };

  //  menu seleced from archive dropdown
  const handleMenuClick = (e) => {
    if (e.key === "archive_shipment") {
      setDeleteShipmentModalOpen(true);
    } else if (e.key === "edit_shipment") {
      handleEditShipmentModal();
    } else {
      handleMarkAsDevliered();
    }
  };

  const getPressureTagClass = (shipment) => {
    const pressure = parseFloat(shipment?.monitor_info?.pressure);
    const max = parseFloat(shipment?.product?.pressure_max);
    const min = parseFloat(shipment?.product?.pressure_min);

    const isOutOfRange =
      !isNaN(pressure) &&
      ((!isNaN(max) && pressure > max) || (!isNaN(min) && pressure < min));

    return `custom-pressure-tag${isOutOfRange ? " danger" : ""}`;
  };

  const getTagStyles = (min, max, current) => {
    if (current === null || current === undefined || current === "") {
      return {
        backgroundColor: "#F3F3F3", // light gray
        color: "#333333", // dark gray text
      };
    }

    const numericCurrent = Number(current);
    const numericMin = typeof min === "number" ? min : undefined;
    const numericMax = typeof max === "number" ? max : undefined;

    // Case: Exact match with min or max
    if (
      (numericMin !== undefined && numericCurrent === numericMin) ||
      (numericMax !== undefined && numericCurrent === numericMax)
    ) {
      return {
        backgroundColor: "#EAF6ED", // green bg
        color: "#0E8345", // green text
      };
    }

    // Case: Both min and max are defined
    if (numericMin !== undefined && numericMax !== undefined) {
      const range = numericMax - numericMin;
      const lowerBound = numericMin + range * 0.2;
      const upperBound = numericMax - range * 0.2;

      if (numericCurrent < numericMin || numericCurrent > numericMax) {
        return {
          backgroundColor: "#FFF0EE", // light red bg
          color: "#BB032A", // red text
        };
      } else if (numericCurrent < lowerBound || numericCurrent > upperBound) {
        return {
          backgroundColor: "#FDF2DC", // light orange bg
          color: "#9F6402", // orange text
        };
      } else {
        return {
          backgroundColor: "#EAF6ED", // green bg
          color: "#0E8345", // green text
        };
      }
    }

    // Case: Single value provided (min or max only)
    const reference = numericMin ?? numericMax;

    if (typeof reference === "number") {
      const diff = Math.abs(numericCurrent - reference);
      const threshold = reference * 0.2;

      if (numericCurrent === reference) {
        return {
          backgroundColor: "#EAF6ED",
          color: "#0E8345",
        };
      } else if (diff <= threshold) {
        return {
          backgroundColor: "#FDF2DC", // light orange
          color: "#9F6402", // orange text
        };
      } else {
        return {
          backgroundColor: "#FFF0EE", // light red
          color: "#BB032A", // red text
        };
      }
    }

    // Default fallback
    return {
      backgroundColor: "#EAF6ED",
      color: "#0E8345",
    };
  };

  const getBatteryTagStyles = (battery) => {
    if (battery === null || battery === undefined || battery === "") {
      return {
        backgroundColor: "#F3F3F3", // light gray for no value
        color: "#333333", // dark gray text
      };
    }

    if (battery <= 10) {
      return {
        backgroundColor: "#FFF0EE", // light red
        color: "#BB032A", // red text
      };
    }

    if (battery <= 20) {
      return {
        backgroundColor: "#FDF2DC", // light orange
        color: "#9F6402", // orange text
      };
    }

    return {
      backgroundColor: "#EAF6ED", // light green
      color: "#0E8345", // green text
    };
  };

  const getVibilityWindowStyles = (
    current,
    status,
    scheduled_delivery_date
  ) => {
    if (!current || current === "00:00:00") {
      return {
        backgroundColor: "#f3f3f3", // light gray
        color: "#333333", // dark gray
      };
    }

    const now = new Date();
    const scheduledDate = new Date(scheduled_delivery_date);

    const isDelayedAndDelivered =
      status?.toLowerCase() !== "delivered" && now > scheduledDate;

    if (isDelayedAndDelivered) {
      return {
        backgroundColor: "#FFF0EE", // light red
        color: "#BB032A", // red
      };
    }

    return {
      backgroundColor: "#EAF6ED", // light green
      color: "#0E8345", // green
    };
  };

  // for link shipment tag colors
  const getStatusStyles = (status) => {
    switch (status?.toUpperCase()) {
      case "LOW BATTERY":
        return { backgroundColor: "#fdf2dc", color: "#9f6402" };
      case "DELIVERED":
        return { backgroundColor: "#28a745", color: "#fff" };
      case "AWAITING PICKUP":
      case "IN-TRANSIT":
      case "PENDING":
      case "NOT FOUND":
        return { backgroundColor: "#f3f3f3", color: "#4b4b4b" };
      default:
        return { backgroundColor: "#e0e0e0", color: "#000" }; // fallback style
    }
  };

  return (
    <>
      {/* <GoogleMapsProvider> */}
      {/* <div className={`custom-card-drawer ${isOpen ? "open" : ""}`}> */}
      <Flex vertical={true} gap={20}>
        <Flex
          gap={16}
          justify="space-between"
          align="center"
          className="custom-card-drawer-header"
          style={{ marginBottom: alertsArray?.length > 0 ? "0px" : "16px" }}
        >
          <Row>
            <Col>
              <CustomTitle
                text="Reference ID"
                fontSize={10}
                color="#5E5E5E"
                fontWeight={600}
                lineHeight={"16px"}
                marginBottom={"0px"}
              />
              {(shipment?.reference_number?.length || 0) > 23 ? (
                <Tooltip title={shipment.reference_number}>
                  <span>
                    <CustomTitle
                      text={truncateByLength(shipment.reference_number, 23)}
                      fontSize={15}
                      fontWeight={700}
                      lineHeight="24px"
                      marginTop={"0px"}
                      color="#000"
                      marginBottom="0"
                    />
                  </span>
                </Tooltip>
              ) : (
                <CustomTitle
                  text={shipment?.reference_number || ""}
                  fontSize={15}
                  fontWeight={700}
                  lineHeight="24px"
                  marginTop={"0px"}
                  color="#000"
                  marginBottom="0"
                />
              )}
            </Col>
          </Row>

          <Flex
            gap={6}
            align="center"
            className="custom-card-drawer-header-actions"
          >
            <BellFilled
              onClick={() => {
                toggleDrawer("open", "notifications", shipmentId);
              }}
              style={{
                cursor: "pointer",
                color: shipment?.has_notification ? "#3D81FF" : "#000000",
              }}
            />
            <CircleGroup viewers={viewers} />
            <span
              title="Expand map"
              onClick={goToExternalView}
              style={{ padding: "4px" }}
            >
              <FullscreenOutlined
                color="#000"
                style={{ fontSize: "14px", color: "#000" }}
              />
            </span>

            <span
              title="Share"
              onClick={handleShareShipmentModal}
              style={{ padding: "4px" }}
            >
              <img
                src={ShareIcon}
                alt=""
                style={{ width: "16px", height: "16px" }}
              />
            </span>

            {allPermissions?.is_update && (
              <>
                {/* <span
                  title="Edit"
                  onClick={handleEditShipmentModal}
                  style={{ padding: "4px" }}
                >
                  <img
                    src={EditIcon}
                    alt=""
                    style={{ width: "16px", height: "16px" }}
                  />
                </span> */}

                <Dropdown
                  menu={{ items, onClick: handleMenuClick }}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <span title="Archive" style={{ padding: "4px" }}>
                    <img
                      src={ArchiveOptionsIcon}
                      alt=""
                      style={{ width: "16px", height: "16px" }}
                    />
                  </span>
                </Dropdown>
              </>
            )}
            {/* )} */}

            <span
              title="Close"
              className="no-bg"
              style={{ padding: "4px" }}
              onClick={() => toggleDrawer("close")}
            >
              <CloseOutlined
                color="#000"
                style={{ fontSize: "14px", color: "#000" }}
              />
            </span>
          </Flex>
        </Flex>

        {alertsArray?.length > 0 &&
          alertsArray.map((alert, index) => {
            return (
              <React.Fragment key={alert.id}>
                {alertIndex === index && (
                  <>
                    <div
                      style={{
                        marginBottom:
                          alertsArray?.length === 1 && openAlertInput === false
                            ? "18px"
                            : "0px",
                      }}
                    >
                      <StatusCardNotification
                        cardStyle={"style-2"}
                        icon={<WarningFilled />}
                        title={alert?.title || ""}
                        description={alert?.detail || ""}
                        useAiButton={alert?.can_use_ai}
                        aiStatus={alert?.ai_status}
                        createdAt={alert?.created_at || ""}
                        shipment={shipment}
                        bgColor={
                          alert?.is_critical === false ? "#F6BC2F" : "#DE1135"
                        }
                        color={alert?.is_critical === false ? "#000" : "#fff"}
                        actionButtonText={"Mark as Resolved"}
                        actionButtonWidth="112px"
                        actionButtonBorderRadius="8px"
                        actionButtonBgColor={
                          alert?.is_critical === false ? "#FBE5B6" : "#BB032A"
                        }
                        dismissAction={() =>
                          handleDismissedAlert(false, alert?.id)
                        }
                        actionButtonOnClick={() =>
                          handleAlertResolved(true, alert?.id)
                        }
                        isCritical={alert.is_critical}
                        aiOptions={[
                          {
                            key: "call",
                            label: "Call phone",
                            icon: (
                              <img
                                src={phoneblack}
                                alt="Call"
                                style={{ width: "14px", height: "14px" }}
                              />
                            ),
                            onClick: () => {
                              setSelectedAlert(alertsArray[alertIndex]);
                              decodedToken?.ai_static_message === false
                                ? handleAiCallConfirm(
                                    alertsArray[alertIndex],
                                    shipment
                                  )
                                : setShowAiModal(true);
                            },
                            disabled: !shipment?.tp_primary_contact?.phone,
                          },
                          {
                            key: "email",
                            label: "Send email",
                            icon: (
                              <img
                                src={mail}
                                alt="Call"
                                style={{ width: "14px", height: "14px" }}
                              />
                            ),
                            onClick: () => {
                              const currentAlert = alertsArray[alertIndex];
                              setSelectedAlert(currentAlert);
                              console.log(
                                "--- TESTING: Data for Email Template ---"
                              );
                              console.log("Alert Object:", currentAlert);
                              console.log("Shipment Object:", shipment);
                              console.log(
                                "-----------------------------------------"
                              );

                              if (
                                decodedToken?.ai_email_static_message === false
                              ) {
                                setShowEmailModal(true);
                              } else {
                                setShowEmailAiModal(true);
                              }
                            },
                            disabled: !shipment?.tp_primary_contact?.email,
                          },
                        ]}
                      />
                    </div>

                    {alertsArray.length > 1 && (
                      <Flex
                        style={{ marginTop: "-18px" }}
                        justify="space-between"
                        align="center"
                        className="custom-card-drawer-header"
                      >
                        <p
                          style={{
                            color: "#000",
                            marginBottom: "0px",
                            fontSize: "12px",
                          }}
                        >
                          {alertIndex + 1} of {alertsArray.length} issues
                        </p>

                        <Flex
                          gap={8}
                          align="center"
                          className="custom-card-drawer-header-actions"
                        >
                          <button
                            style={{ border: 0, borderRadius: "50px" }}
                            title="Previous Alert"
                            onClick={() => {
                              if (alertIndex > 0) {
                                setAlertIndex(alertIndex - 1); // Decrease the alertIndex by 1
                              }
                            }}
                          >
                            <LeftOutlined
                              style={{
                                fontSize: "12px",
                                color: index === 0 ? "#AFAFAF" : "#000",
                              }}
                            />
                          </button>

                          <button
                            style={{ border: 0, borderRadius: "50px" }}
                            title="Next Alert"
                            onClick={() => {
                              if (alertIndex < alertsArray.length - 1) {
                                setAlertIndex(alertIndex + 1); // Decrease the alertIndex by 1
                              }
                            }}
                          >
                            <RightOutlined
                              style={{
                                fontSize: "12px",
                                color:
                                  index === alertsArray.length - 1
                                    ? "#AFAFAF"
                                    : "#000",
                              }}
                            />
                          </button>
                        </Flex>
                      </Flex>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}

        <>
          {openAlertInput && (
            <div>
              <>
                <ShipmentCommentBox
                  onTextareaChange={onAlertTextareaChange}
                  error={commentsInputError}
                />
                <div style={{ marginBottom: "18px" }}>
                  <Flex gap={16}>
                    <CustomButton
                      text={"Cancel"}
                      width="70px"
                      height="36px"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      borderRadius="8px"
                      bgColor="#F3F3F3"
                      color="#000"
                      boxShadow="none"
                      onClick={handleToggleAlertInput}
                      iconPosition="left"
                      gap={8}
                    />
                    <CustomButton
                      text={"Submit comment"}
                      width="147px"
                      height="36px"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      borderRadius="8px"
                      bgColor="#000"
                      color="#fff"
                      boxShadow="none"
                      onClick={() => onSubmitAlertComment()}
                      iconPosition="left"
                      gap={8}
                    />
                  </Flex>
                </div>
              </>
            </div>
          )}
        </>

        <Row gap={24} justify="space-between" style={{ marginTop: "-20px" }}>
          <Col span={11}>
            <CustomParagraph
              text={"Delivery status"}
              fontSize={12}
              fontWeight={600}
              lineHeight="20px"
              color="#000"
              marginBottom="4px"
            />
            <Tag
              color={
                shipment?.delivery_status?.toLowerCase().includes("on time") ||
                shipment?.delivery_status?.toLowerCase() === "delivered"
                  ? "#EAF6ED"
                  : shipment?.delivery_status?.includes("Late")
                  ? "#FFF0EE"
                  : "rgb(243, 243, 243)"
              }
              style={{
                borderRadius: "8px",
                color:
                  shipment?.delivery_status?.toLowerCase() === "on time" ||
                  shipment?.delivery_status?.toLowerCase() === "delivered"
                    ? "#0E8345"
                    : shipment?.delivery_status?.includes("Late")
                    ? "#DE1135"
                    : "rgb(75, 75, 75)",
                fontSize: "10px",
              }}
            >
              {shipment?.delivery_status}
            </Tag>
          </Col>

          <Col span={11}>
            <CustomParagraph
              text={shipment?.type === 3 ? "Delivered on" : "ZoomLogi ETA"}
              fontSize={12}
              fontWeight={600}
              lineHeight="20px"
              color="#000"
              marginBottom="4px"
            />

            <CustomParagraph
              text={
                shipment?.type === 3
                  ? shipment?.actual_delivery_date
                  : shipment?.estimated_delivery_date
              }
              fontSize={12}
              fontWeight={400}
              lineHeight="16px"
              color="#4B4B4B"
              marginBottom="0"
            />
          </Col>
        </Row>
        {/* map  */}
        <div className="">
          <div className="map-container is-detail-shipment-map is-detail-shipment-map-h">
            <GoogleMapsProvider>
              <ShipmentMap
                currentView="summary"
                lastCoordinates={lastPoint}
                shipment={shipment}
                height={"240px"}
                isLargeScreen={false}
              />
            </GoogleMapsProvider>
          </div>
        </div>

        <Flex vertical={true} gap={16}>
          <Flex
            justify="space-between"
            align="center"
            gap={6}
            style={{ flexWrap: "wrap" }}
          >
            <CustomTitle
              text={"Shipment details"}
              fontSize={15}
              fontWeight={700}
              lineHeight="24px"
              color="#000"
              marginBottom="0"
              style={{ width: "200px" }}
            />

            <Flex gap={8} style={{ flexWrap: "wrap" }}>
              {/* temprature tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Temperature sensor reading  </span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={
                    <TempratureRangeIcon
                      style={{ fill: "#ffcc00", width: 14, height: 14 }}
                    />
                  }
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    fontWeight: "600",
                    backgroundColor: "#EAF6ED",
                    color: "#0E8345",
                    border: "none",
                    ...getTagStyles(
                      shipment?.product?.temperature_min,
                      shipment?.product?.temperature_max,
                      shipment?.monitor_info?.temperature
                    ),
                  }}
                  onClick={handleTempratureModal}
                >
                  {/* {shipment?.monitor_info?.temperature
                    ? parseInt(shipment?.monitor_info?.temperature) || '--'
                    : '--'} */}
                  {shipment?.monitor_info?.temperature != null &&
                  !isNaN(parseInt(shipment.monitor_info.temperature))
                    ? parseInt(shipment.monitor_info.temperature)
                    : "--"}
                  °C
                </Tag>
              </Tooltip>
              {/* Battery tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Sensor battery life</span>  <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={
                    <BatteryIcon
                      style={{ fill: "#ffcc00", width: 14, height: 14 }}
                    />
                  }
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    ...getBatteryTagStyles(shipment?.monitor_info?.battery),
                  }}
                  onClick={handleBatteryModal}
                >
                  {/* {shipment?.monitor_info?.battery
                    ? parseInt(shipment?.monitor_info?.battery) || '--'
                    : '--'} */}
                  {shipment?.monitor_info?.battery != null &&
                  !isNaN(parseInt(shipment.monitor_info.battery))
                    ? parseInt(shipment.monitor_info.battery)
                    : "--"}
                  %
                </Tag>
              </Tooltip>
              {/* light tag  */}
              {shipment?.product?.light && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Light sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={
                      <LightIcon
                        style={{ fill: "#ffcc00", width: 14, height: 14 }}
                      />
                    }
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        "",
                        shipment?.product?.light,
                        shipment?.monitor_info?.light
                      ),
                    }}
                    onClick={handleLightModal}
                  >
                    {shipment?.monitor_info?.light != null &&
                    !isNaN(parseInt(shipment.monitor_info.light))
                      ? parseInt(shipment.monitor_info.light)
                      : "--"}
                    lx
                  </Tag>
                </Tooltip>
              )}
              {/* humidity tag  */}
              {shipment?.product?.humidity_max &&
              shipment?.product?.humidity_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Humidity sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    icon={
                      <HumidityIcon
                        style={{ fill: "#ffcc00", width: 14, height: 14 }}
                      />
                    }
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      padding: "0 4px",
                      minWidth: "20px",
                      fontWeight: "600",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.humidity_min,
                        shipment?.product?.humidity_max,
                        shipment?.monitor_info?.humidity
                      ),
                    }}
                    onClick={handleHumidityModal}
                  >
                    {shipment?.monitor_info?.humidity != null &&
                    !isNaN(parseInt(shipment.monitor_info.humidity))
                      ? parseInt(shipment.monitor_info.humidity)
                      : "--"}
                    %
                  </Tag>
                </Tooltip>
              ) : null}
              {/* Tilt tag  */}
              {shipment?.product?.tilt && (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Tilt sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    onClick={handleTiltModal}
                    icon={
                      <TiltIcon
                        style={{ fill: "#ffcc00", width: 14, height: 14 }}
                      />
                      // <img src={tiltIcon} alt="" />
                    }
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        "",
                        shipment?.product?.tilt,
                        shipment?.monitor_info?.tilt
                      ),
                    }}
                  >
                    {shipment?.monitor_info?.tilt != null &&
                    !isNaN(parseInt(shipment.monitor_info.tilt))
                      ? parseInt(shipment.monitor_info.tilt)
                      : "--"}
                    °
                  </Tag>
                </Tooltip>
              )}
              {/* pressure tag  */}
              {shipment?.product?.pressure_max &&
              shipment?.product?.pressure_min ? (
                <Tooltip
                  placement="top"
                  title={
                    <p
                      className="fw-semibold"
                      dangerouslySetInnerHTML={{
                        __html: `<span>Pressure sensor reading</span> <br/> ${
                          shipment?.monitor_info?.timestamp || ""
                        } `,
                      }}
                    />
                  }
                  arrow={true}
                >
                  <Tag
                    onClick={handlePressureModal}
                    icon={
                      <PressureIcon
                        style={{ fill: "#ffcc00", width: 14, height: 14 }}
                      />
                    }
                    style={{
                      margin: "0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gridGap: "3px",
                      cursor: "pointer",
                      height: "20px",
                      fontWeight: "600",
                      padding: "0 4px",
                      minWidth: "20px",
                      backgroundColor: "#EAF6ED",
                      border: "none",
                      color: "#0E8345",
                      ...getTagStyles(
                        shipment?.product?.pressure_min,
                        shipment?.product?.pressure_max,
                        shipment?.monitor_info?.pressure
                      ),
                    }}
                  >
                    {shipment?.monitor_info?.pressure != null &&
                    !isNaN(parseInt(shipment.monitor_info.pressure))
                      ? parseInt(shipment.monitor_info.pressure)
                      : "--"}

                    {shipment?.product?.pressure_unit}
                  </Tag>
                  {/* <div
                    className={getPressureTagClass(shipment)}
                    onClick={handlePressureModal}
                  >
                    <svg
                      style={{ width: "12px", height: "12px" }}
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M5.33582 5.66418C5.66914 5.99751 6.20958 5.99751 6.54291 5.66418C6.87624 5.33086 7.75 3.25 7.75 3.25C7.75 3.25 5.66914 4.12376 5.33582 4.45709C5.00249 4.79042 5.00249 5.33086 5.33582 5.66418Z"
                        fill="#0E8345"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 1C3.79086 1 2 2.79086 2 5C2 6.86384 3.27477 8.42994 5 8.87398V10H1.25C1.11193 10 1 10.1119 1 10.25V11.25C1 11.3881 1.11193 11.5 1.25 11.5H10.75C10.8881 11.5 11 11.3881 11 11.25V10.25C11 10.1119 10.8881 10 10.75 10H7V8.87398C8.72523 8.42994 10 6.86384 10 5C10 2.79086 8.20914 1 6 1ZM3 5C3 3.34315 4.34315 2 6 2C7.65685 2 9 3.34315 9 5C9 6.65685 7.65685 8 6 8C4.34315 8 3 6.65685 3 5Z"
                        fill="#0E8345"
                      />
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6 9C8.20914 9 10 7.20914 10 5C10 2.79086 8.20914 1 6 1C3.79086 1 2 2.79086 2 5C2 7.20914 3.79086 9 6 9ZM6 9.5C8.48528 9.5 10.5 7.48528 10.5 5C10.5 2.51472 8.48528 0.5 6 0.5C3.51472 0.5 1.5 2.51472 1.5 5C1.5 7.48528 3.51472 9.5 6 9.5Z"
                        fill="#0E8345"
                      />
                    </svg>
                    {shipment?.monitor_info?.pressure
                      ? ` ${parseInt(shipment?.monitor_info?.pressure)} ${
                          shipment?.product?.pressure_unit
                        }` || 0
                      : 0}
                  </div> */}
                </Tooltip>
              ) : null}
              {/* vibility window tag  */}
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: "<span>Viable transit time remaining</span>",
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={
                    <VibilityWindowIcon
                      style={{ fill: "#ffcc00", width: 14, height: 14 }}
                    />
                    // <img src={time} alt="" />
                  }
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    fontWeight: "600",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                    width: "fit-content",
                    ...getVibilityWindowStyles(
                      shipment?.schedule_viability_window,
                      shipment?.status,
                      shipment?.scheduled_delivery_date
                    ),
                  }}
                >
                  {changeToTimeString(shipment?.schedule_viability_window) ||
                    "--hr --min"}
                </Tag>
              </Tooltip>
            </Flex>
          </Flex>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Origin"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={[shipment?.from_location?.name]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.from_location?.parsed_address?.AddressNumber,
                  shipment?.from_location?.parsed_address?.StreetName,
                  shipment?.from_location?.parsed_address?.StreetNamePostType,
                ]
                  .filter(Boolean)
                  .join(" ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.from_location?.parsed_address?.PlaceName,
                  shipment?.from_location?.parsed_address?.StateName,
                  shipment?.from_location?.parsed_address
                    ?.ZipCode ||
                    shipment?.from_location?.parsed_address
                      ?.SubaddressIdentifier,
                ]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Destination"}
                fontSize={12}
                fontWeight={600}
                lineHeight="20px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={[shipment?.to_location?.name].filter(Boolean).join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.to_location?.parsed_address?.AddressNumber,
                  shipment?.to_location?.parsed_address?.StreetName,
                  shipment?.to_location?.parsed_address?.StreetNamePostType,
                ]
                  .filter(Boolean)
                  .join(" ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.to_location?.parsed_address?.PlaceName,
                  shipment?.to_location?.parsed_address?.StateName,
                  shipment?.to_location?.parsed_address?.ZipCode ||
                    shipment?.to_location?.parsed_address?.SubaddressIdentifier,
                ]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Scheduled pickup"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.scheduled_pickup_date}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Scheduled delivery"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.scheduled_delivery_date}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Total weight (kg)"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.weight_kg}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Dimensions"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={
                  shipment?.volume
                    ? `${shipment.volume} Inch`
                    : "0 L x 0 W x 0 H Inch"
                }
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Total commercial value"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.total_commercial}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Reference ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.reference_number}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          {/* Linked shipments START  */}

          {shipment?.linked_shipments?.length > 0 && (
            <div>
              <Row
                justify="space-between"
                align="middle"
                style={{ marginBottom: "8px", marginTop: "10px" }}
              >
                <Col>
                  <CustomTitle
                    text={"Linked shipments"}
                    fontSize={15}
                    fontWeight={700}
                    lineHeight="28px"
                    color="#000"
                    marginBottom="0"
                  />
                </Col>
                <Col>
                  <Button
                    type="text"
                    style={{
                      backgroundColor: "#F3F3F3",
                      borderRadius: "8px",
                      height: "28px",
                      padding: "4px 8px",
                    }}
                    onClick={() => filterByLinkCode(shipment?.link_code)}
                  >
                    <img
                      style={{ height: "12px" }}
                      src={FilterIconBlack}
                      alt="Filter"
                    />

                    <CustomParagraph
                      text={"View"}
                      fontSize={12}
                      fontWeight={600}
                      lineHeight="16px"
                      color="#000"
                      marginBottom={0}
                    />
                  </Button>
                </Col>
              </Row>

              {shipment?.linked_shipments.map((shipment) => (
                <Card
                  key={shipment.id}
                  style={{
                    marginBottom: "8px",
                    borderRadius: "12px",
                    border: "2px solid #E2E2E2",
                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                    cursor: "pointer",
                  }}
                  bodyStyle={{ padding: "16px" }}
                  onClick={() => {
                    setShipmentId(shipment?.id);
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Flex>
                      <Space>
                        {shipment.reference_id.length > 15 ? (
                          <Tooltip title={shipment.reference_id}>
                            <span>
                              <CustomParagraph
                                text={truncateByLength(
                                  shipment.reference_id,
                                  15
                                )}
                                fontSize={14}
                                fontWeight={600}
                                lineHeight="16px"
                                color="#000"
                                marginBottom={0}
                              />
                            </span>
                          </Tooltip>
                        ) : (
                          <CustomParagraph
                            text={truncateByLength(shipment.reference_id, 15)}
                            fontSize={14}
                            fontWeight={600}
                            lineHeight="16px"
                            color="#000"
                            marginBottom={0}
                          />
                        )}
                        <Tag
                          style={{
                            backgroundColor: "#f3f3f3",
                            color: "#5e5e5e",
                            fontSize: "10px",
                            fontWeight: 600,
                            lineHeight: "16px",
                            border: "none",
                            borderRadius: "4px",
                            padding: "2px 10px",
                            ...getStatusStyles(shipment.status.toLowerCase()),
                          }}
                        >
                          {shipment.status}
                        </Tag>
                      </Space>
                    </Flex>
                    <Flex>
                      <Space>
                        <CustomParagraph
                          text={shipment.route}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="20px"
                          color="#000"
                          marginBottom={0}
                        />
                      </Space>
                    </Flex>
                  </div>
                </Card>
              ))}
            </div>
          )}

          {/* Linked shipments END */}

          <Flex justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Product details"}
              fontSize={15}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0"
            />
          </Flex>

          <Row gap={24} justify="space-between">
            {/* product name  */}
            <Col span={11}>
              <CustomParagraph
                text={"Product"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />
              <CustomParagraph
                // text={
                //   Array.isArray(shipment?.products)
                //     ? shipment.products.map((p) => capitalize(p.name)).join(", ")
                //     : capitalize(shipment?.product?.name) || "--"
                // }
                text={shipment?.product?.name}
                noText="--"
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
            {/* quantity */}
            <Col span={11}>
              {shipment?.product?.project_id &&
              shipment.product.project_id.includes(",") ? (
                <Tooltip
                  title={
                    <div
                      style={{
                        textAlign: "center",
                        whiteSpace: "normal",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "120%",
                      }}
                    >
                      Total number of all products{" "}
                    </div>
                  }
                  overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                  placement="top"
                >
                  <CustomParagraph
                    text={"Product quantity"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={
                      shipment?.product?.quantity
                        ? shipment?.product?.quantity
                        : "--"
                    }
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </Tooltip>
              ) : (
                <>
                  <CustomParagraph
                    text={"Product quantity"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={
                      shipment?.product?.quantity
                        ? shipment?.product?.quantity
                        : "--"
                    }
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </>
              )}
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            {/* product type  */}
            <Col span={11}>
              <CustomParagraph
                text={"Product type"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />
              <CustomParagraph
                // text={
                //   Array.isArray(shipment?.products)
                //     ? shipment.products
                //         .map((p) => capitalize(p.product_type))
                //         .join(", ")
                //     : capitalize(shipment?.product?.product_type) || "--"
                // }
                text={shipment?.product?.product_type}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            {/* project id  */}
            <Col span={11}>
              {shipment?.product?.project_id &&
              shipment.product.project_id.includes(",") ? (
                // If multiple project IDs, show Tooltip
                <Tooltip
                  title={
                    <div
                      style={{
                        textAlign: "center",
                        whiteSpace: "normal",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "120%",
                      }}
                    >
                      {shipment.product.project_id}
                    </div>
                  }
                  placement="top"
                >
                  <span>
                    <CustomParagraph
                      text={"Project ID"}
                      fontSize={12}
                      fontWeight={600}
                      lineHeight="16px"
                      color="#000"
                      marginBottom="4px"
                    />
                    <CustomParagraph
                      text={(() => {
                        const projectIds =
                          shipment.product.project_id.split(",");
                        return projectIds.length > 2
                          ? `${projectIds.slice(0, 2).join(", ")}, +${
                              projectIds.length - 2
                            }`
                          : projectIds.join(", ");
                      })()}
                      noText="--"
                      fontSize={12}
                      fontWeight={400}
                      lineHeight="16px"
                      color="#4B4B4B"
                      marginBottom="0"
                    />
                  </span>
                </Tooltip>
              ) : (
                // If only one project ID, no Tooltip
                <span>
                  <CustomParagraph
                    text={"Project ID"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={shipment?.product?.project_id || "--"}
                    noText="--"
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </span>
              )}
            </Col>
          </Row>
          <Row gap={24} justify="space-between">
            {/* temperature range  */}
            <Col span={11}>
              {shipment?.product?.project_id &&
              shipment.product.project_id.includes(",") ? (
                <Tooltip
                  title={
                    <div
                      style={{
                        textAlign: "center",
                        whiteSpace: "normal",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "120%",
                      }}
                    >
                      Temperature range overlap for all products
                    </div>
                  }
                  overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                  placement="top"
                >
                  <CustomParagraph
                    text={"Temperature range"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={shipment?.product?.temperature_range}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </Tooltip>
              ) : (
                <span>
                  <CustomParagraph
                    text={"Temperature range"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={shipment?.product?.temperature_range}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </span>
              )}
            </Col>

            {/* Transit viability window */}
            <Col span={11}>
              {shipment?.product?.project_id &&
              shipment.product.project_id.includes(",") ? (
                <Tooltip
                  title={
                    <div
                      style={{
                        textAlign: "center",
                        whiteSpace: "normal",
                        fontSize: "12px",
                        fontWeight: "600",
                        lineHeight: "120%",
                      }}
                    >
                      Minimum viability window for all product types
                    </div>
                  }
                  overlayStyle={{ maxWidth: "154px" }}
                  placement="top"
                >
                  <CustomParagraph
                    text={"Transit viability window"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={
                      shipment?.product?.viability_window
                        ? shipment?.product?.viability_window + " hrs"
                        : "--"
                    }
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </Tooltip>
              ) : (
                <>
                  <CustomParagraph
                    text={"Transit viability window"}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="4px"
                  />

                  <CustomParagraph
                    text={
                      shipment?.product?.viability_window
                        ? shipment?.product?.viability_window + " hrs"
                        : "--"
                    }
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                </>
              )}
            </Col>
          </Row>
          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Sensor"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.sensor?.type ? shipment?.sensor?.type : "--"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Sensor ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.sensor?.id ? shipment?.sensor?.id : "--"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          {/* transport provider  */}

          <Flex justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Transport provider"}
              fontSize={15}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0"
            />
          </Flex>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Transport provider"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.courier?.title}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Contact phone"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.contact_phone}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Tracking ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />
              {shipment?.courier?.tracking_link ? (
                <>
                  <a
                    href={shipment.courier.tracking_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      // textDecoration: "underline",
                      fontSize: 12,
                      fontWeight: 400,
                      lineHeight: "16px",
                      color: "#4B4B4B",

                      cursor: "pointer",
                      display: "inline-block",
                    }}
                  >
                    <Tooltip title={shipment?.courier_tracking_id}>
                      <span>
                        {truncateByLength(shipment?.courier_tracking_id, 18)}
                      </span>
                    </Tooltip>
                    <img
                      src={arrowLink}
                      alt="arrow"
                      width={15}
                      style={{ marginLeft: "3px" }}
                    />
                  </a>
                </>
              ) : (
                <span
                  style={{
                    fontSize: 12,
                    fontWeight: 400,
                    lineHeight: "16px",
                    color: "#4B4B4B",
                    display: "inline-block",
                  }}
                >
                  <Tooltip title={shipment?.courier_tracking_id}>
                    <span>
                      {truncateByLength(shipment?.courier_tracking_id, 23)}
                    </span>
                  </Tooltip>
                </span>
              )}

              {/* <CustomParagraph
                text={shipment?.courier_tracking_id}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              /> */}
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Transport provider ETA"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.transport_provider_eta}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>
          {/* chain of custody  */}
          <Flex wrap justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Live chain of custody"}
              fontSize={15}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0px"
            />
            <Flex wrap gap={10}>
              {!openCommentInput && (
                <CustomButton
                  text="Upload File"
                  width="105px"
                  height="28px"
                  padding={"6px 10px"}
                  fontSize="12px"
                  fontWeight="600"
                  lineHeight="20px"
                  borderRadius="8px"
                  bgColor="#F3F3F3"
                  color="#000"
                  boxShadow="none"
                  imageWidth="17px"
                  onClick={() => setUploadModalOpen(true)}
                  iconPosition="left"
                  gap={8}
                  image={UploadIcon}
                />
              )}
              <FileUploadModal
                fetchSingleShipmentData={fetchSingleShipmentData}
                token={token}
                shipmentId={shipmentId}
                modalOpen={uploadModalOpen}
                setModalOpen={setUploadModalOpen}
              />
              {!openCommentInput && (
                <CustomButton
                  text={"Add comment"}
                  width="120px"
                  height="28px"
                  padding={"6px 8px"}
                  fontSize="12px"
                  fontWeight="600"
                  lineHeight="20px"
                  borderRadius="8px"
                  bgColor="#F3F3F3"
                  color="#000"
                  boxShadow="none"
                  onClick={onAddCommentClick}
                  iconPosition="left"
                  gap={8}
                  image={CommentIcon}
                />
              )}
            </Flex>
            {openCommentInput && (
              <div>
                <Flex gap={16}>
                  <CustomButton
                    text={"Cancel"}
                    width="70px"
                    height="36px"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="16px"
                    borderRadius="8px"
                    bgColor="#F3F3F3"
                    color="#000"
                    boxShadow="none"
                    onClick={onCancelComments}
                    iconPosition="left"
                    gap={8}
                  />
                  <CustomButton
                    text={"Submit comment"}
                    width="147px"
                    height="36px"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="16px"
                    borderRadius="8px"
                    bgColor="#000"
                    color="#fff"
                    boxShadow="none"
                    onClick={onSubmitComments}
                    iconPosition="left"
                    gap={8}
                  />
                </Flex>
              </div>
            )}
          </Flex>

          {openCommentInput && (
            <ShipmentCommentBox
              onTextareaChange={onTextareaChange}
              error={commentsInputError}
            />
          )}

          <div
            className="custom-timeline"
            style={{
              position: "relative",
              paddingRight: "50px",
              marginTop: "5px",
            }}
          >
            <Timeline mode="left">
              {shipment?.chain_of_custody?.map((custody, index) => (
                <Timeline.Item
                  key={index}
                  dot={
                    custody?.type == 1 ? (
                      <img
                        src={CommentIcon}
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : custody?.type == 3 && custody?.is_critical === 0 ? (
                      <img
                        src={AtRisk}
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : custody?.is_critical === 1 && custody?.type == 3 ? (
                      <Flex
                        align="center"
                        justify="center"
                        style={{
                          backgroundColor: "#DE1135",
                          borderRadius: "50%",
                          width: "26px",
                          height: "26px",
                        }}
                      >
                        <span style={{ fontSize: "13px", color: "white" }}>
                          <ExclamationCircleFilled />
                        </span>
                      </Flex>
                    ) : custody?.file && custody?.type === 4 ? (
                      <>
                        <img src={FileImg}></img>

                        {/* <Flex
                          style={{
                            position: "absolute",
                            top: "-15px",
                            left: "395px",
                            padding: "8px",
                            zIndex: 1,
                          }}
                        >
                          {/* <CustomButton
                            width="36px"
                            height="36px"
                            bgColor="#F3F3F3"
                            borderRadius="50px"
                            color="#000"
                            padding="10px"
                            boxShadow="none"
                            border="none"
                            iconPosition="right"
                            onClick={() => downloadFile(custody?.file)}
                            image={FileDownload}
                          />
                        </Flex> */}
                      </>
                    ) : (
                      <div
                        style={{
                          backgroundColor: "#000",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                        }}
                      />
                    )
                  }
                >
                  <div
                    style={{
                      position: "relative",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "centr",
                      width: "100%",
                    }}
                  >
                    <CustomParagraph
                      text={custody?.action}
                      fontSize={12}
                      fontWeight={600}
                      lineHeight="16px"
                      color="#000"
                      marginBottom={"4px"}
                      whiteSpace="pre-line"
                      overflowWrap="break-word"
                    />
                    {custody?.file && custody?.type === 4 && (
                      <div
                        style={{
                          position: "absolute",
                          right: "-45px",
                          top: "-8px",
                        }}
                      >
                        <Button
                          type="button"
                          style={{
                            width: "36px",
                            height: "36px",
                            backgroundColor: "#F3F3F3",
                            borderRadius: "50%",
                            color: "#000",
                            padding: "0px",
                            boxShadow: "none",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                          onClick={() => downloadFile(custody?.file)}
                        >
                          <img src={FileDownload} width={16}></img>
                        </Button>
                      </div>
                    )}
                  </div>

                  {/* <CustomParagraph
                    text={String(custody?.action || "")}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="10px"
                  /> */}
                  <CustomParagraph
                    text={String(custody?.comment || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={String(custody?.location || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={String(custody?.timestamp || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                  {custody?.alert_completion?.length > 0 &&
                    custody.alert_completion.map((completion, index) => (
                      <Row
                        key={index}
                        style={{ marginTop: "12px", marginBottom: "12px" }}
                      >
                        <Col
                          span={4}
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            marginRight: "20px",
                          }}
                        >
                          {completion ? (
                            <Flex
                              align="center"
                              justify="center"
                              style={{
                                backgroundColor:
                                  completion.status === "Resolved"
                                    ? "#0E8345"
                                    : completion.status === "Not Resolved"
                                    ? "#000"
                                    : "#000",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize:
                                    completion.status === "Resolved"
                                      ? "15px"
                                      : "12px",
                                  color: "white",
                                }}
                              >
                                {completion.status === "Resolved" ? (
                                  <CheckOutlined />
                                ) : completion.status === "Not Resolved" ? (
                                  <CloseOutlined />
                                ) : (
                                  <MinusOutlined />
                                )}
                              </span>
                            </Flex>
                          ) : null}
                        </Col>
                        <Col style={{ flex: 1, minWidth: 0 }}>
                          {" "}
                          {/* Added style here */}
                          <Flex justify="space-between" align="center">
                            <div style={{ minWidth: 0 }}>
                              <Tooltip title={completion?.title}>
                                <span>
                                  <CustomParagraph
                                    text={completion?.title}
                                    fontSize={12}
                                    fontWeight={600}
                                    lineHeight="16px"
                                    color="#000"
                                    marginBottom={"4px"}
                                    whiteSpace="pre-line"
                                    overflowWrap="break-word"
                                  />
                                </span>
                              </Tooltip>

                              <CustomParagraph
                                text={completion?.comment}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom={"4px"}
                                whiteSpace="pre-line"
                                overflowWrap="break-word"
                              />

                              <CustomParagraph
                                text={String(completion.completed_at || "")}
                                fontSize={12}
                                fontWeight={400}
                                lineHeight="16px"
                                color="#4B4B4B"
                                marginBottom="0"
                              />

                              {completion.ai_type === "call" && (
                                <CustomButton
                                  text="View call transcript"
                                  bgColor="#F3F3F3"
                                  marginTop="10px"
                                  color="black"
                                  fontSize="12px"
                                  fontWeight="600"
                                  borderRadius="28px"
                                  width="128px"
                                  boxShadow="none"
                                  height="28px"
                                  onClick={() => {
                                    setShowTranscriptModal(true);
                                    setAlert(completion);
                                  }}
                                />
                              )}

                              {completion.ai_type === "email" && (
                                <CustomButton
                                  text="View email exchange"
                                  bgColor="#F3F3F3"
                                  color="black"
                                  fontSize="12px"
                                  marginTop="10px"
                                  fontWeight="600"
                                  borderRadius="28px"
                                  width="139px"
                                  boxShadow="none"
                                  height="28px"
                                  onClick={() => {
                                    setShowExchangeModal(true);
                                    setAlert(completion);
                                  }}
                                />
                              )}
                            </div>

                            {/* Right tick icon if resolved and AI type is call or email */}
                            {completion.status &&
                              (completion.ai_type === "call" ||
                                completion.ai_type === "email") && (
                                <Flex
                                  align="center"
                                  justify="center"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    // position: "absolute", // Removed absolute positioning
                                    // right: "-100px",    // Removed absolute positioning
                                  }}
                                >
                                  <StarIcon
                                    style={{
                                      width: "24px",
                                      height: "24px",
                                      // color: "white", // Removed color override
                                    }}
                                  />
                                </Flex>
                              )}
                          </Flex>
                        </Col>
                      </Row>
                    ))}
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        </Flex>
      </Flex>
      {/* </div> */}
      {/* </GoogleMapsProvider> */}

      {shareShipmentModalOpen && (
        <CustomModalWithoutButton
          modalOpen={shareShipmentModalOpen}
          setModalOpen={setShareShipmentModalOpen}
          modalTitle="Share shipment"
          modalText=""
          modalSize={524}
          buttonText1=""
          buttonText2=""
          onConfirmClick={() => console.log("Share Shipment")}
        >
          <ShareShipment shipmentId={shipmentId} token={token} />
        </CustomModalWithoutButton>
      )}

      {deleteShipmentModalOpen && (
        <CustomModalWithoutButton
          modalOpen={deleteShipmentModalOpen}
          setModalOpen={setDeleteShipmentModalOpen}
          modalTitle="Archive Shipment"
          modalText=""
          modalSize={524}
          buttonText1=""
          buttonText2=""
          onConfirmClick={() => console.log("Share Shipment")}
          fontSize={"24px"}
          lineHeight="32px"
        >
          <Flex vertical={true} gap={20}>
            <CustomParagraph
              text="Stop tracking this shipment on ZoomLogi."
              marginTop={"8px"}
              marginBottom={"4px"}
            />

            <Flex gap="16px" justify="end">
              <CustomButton
                text={"Cancel"}
                bgColor="transparent"
                color="black"
                fontSize="16px"
                fontWeight="500"
                boxShadow="none"
                height="32px"
                onClick={() => setDeleteShipmentModalOpen(false)}
              />
              <CustomButton
                text={"Archive Shipment"}
                bgColor="#DE1135"
                color="white"
                width="154px"
                fontSize="16px"
                fontWeight="500"
                boxShadow="none"
                borderRadius="8px"
                htmlType="submit"
                onClick={() => handleDeleteShipmentModal()}
              />
            </Flex>
          </Flex>
        </CustomModalWithoutButton>
      )}
      {showEmailAiModal && (
        <EmailAiAssistantModal
          showEmailModal={showEmailModal}
          setShowEmailModal={setShowEmailModal}
          open={showEmailAiModal}
          onCancel={() => setShowEmailAiModal(false)}
          onConfirm={(dontShowAgain) => {
            console.log("AI Call started");
            console.log("Don't show again:", dontShowAgain);
            setShowEmailAiModal(false);
          }}
        />
      )}
      {showExchangeModal && (
        <AiEmailExchangeModal
          shipment={shipment}
          unauthorize={unauthorize}
          token={token}
          alert={alert}
          open={showExchangeModal}
          onClose={() => setShowExchangeModal(false)}
        />
      )}
      {showEmailModal && (
        <EmailTranscriptModal
          shipment={shipment}
          alert={selectedAlert}
          onConfirm={(message, subject) =>
            handleAiEmailConfirm(selectedAlert, message, subject)
          }
          open={showEmailModal}
          onClose={() => setShowEmailModal(false)}
        />
      )}
      {showAiModal && (
        <CallAiAssistantModal
          showTranscriptModal={showTranscriptModal}
          setShowTranscriptModal={setShowTranscriptModal}
          open={showAiModal}
          onCancel={() => setShowAiModal(false)}
          onConfirm={() => handleAiCallConfirm(selectedAlert, shipment)}
        />
      )}
      {showTranscriptModal && (
        <AiCallTranscriptModal
          shipment={shipment}
          unauthorize={unauthorize}
          token={token}
          alert={alert}
          open={showTranscriptModal}
          onClose={() => setShowTranscriptModal(false)}
        />
      )}
      {humidityModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={humidityModalOpen}
            setModalOpen={setHumidityModalOpen}
            modalTitle="Humidity"
            modalText=""
            modalSize={715}
          >
            <HumidityModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}

      {lightModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={lightModalOpen}
            setModalOpen={setLightModalOpen}
            modalTitle="Light"
            modalText=""
            modalSize={715}
          >
            <LightModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}

      {tempratureModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={tempratureModalOpen}
            setModalOpen={setTempratureModalOpen}
            modalTitle="Temperature"
            modalText=""
            modalSize={715}
          >
            <TemperatureModal
              min={shipment?.product?.temperature_min}
              max={shipment?.product?.temperature_max}
              shipment_monitor={shipment?.shipment_monitor}
            />
          </CustomModalWithoutButton>
        )}

      {/* Tilt Chart modal  */}

      {tiltModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={tiltModalOpen}
            setModalOpen={setTiltModalOpen}
            modalTitle="Tilt"
            modalText=""
            modalSize={615}
          >
            <TiltModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}
      {/* pressure chart modal  */}

      {pressureModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={pressureModalOpen}
            setModalOpen={setPressureModalOpen}
            modalTitle="Pressure"
            modalText=""
            modalSize={715}
          >
            <PressureChartModal
              pressureUnit={shipment?.product}
              min={shipment?.product?.pressure_min}
              max={shipment?.product?.pressure_max}
              shipment_monitor={shipment?.shipment_monitor}
            />
          </CustomModalWithoutButton>
        )}
      {/* battery chart modal  */}
      {batteryModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={batteryModalOpen}
            setModalOpen={setBatteryModalOpen}
            modalTitle="Sensor battery life"
            modalText=""
            modalSize={715}
          >
            <BatteryModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}
    </>
  );
}

export default ShipmentDetailDrawerWithTeams;
